import { render, staticRenderFns } from "./DerwickAssociatesPayments.vue?vue&type=template&id=5144235f&"
import script from "./DerwickAssociatesPayments.vue?vue&type=script&lang=js&"
export * from "./DerwickAssociatesPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports